module.exports = __webpack_public_path__ + "img/horizontal_2_1_0.3f1d2d1c.png";